import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authApi } from "@/lib/api";

const AuthContext = createContext(null);

function isOAuthCallback() {
    const h = window.location.hash || "";
    return h.includes("session_id=");
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const u = await authApi.me();
            setUser(u);
            return u;
        } catch {
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        // During OAuth callback we do NOT call /me — AuthCallback will set user via setUser
        // after creating the session. We still mark loading=false so RouterGate can render
        // AuthCallback. AuthCallback then drives user state.
        if (isOAuthCallback()) {
            setLoading(false);
            return;
        }
        refresh().finally(() => setLoading(false));
    }, [refresh]);

    const logout = async () => {
        try {
            await authApi.logout();
        } catch {}
        setUser(null);
        window.location.href = "/";
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, refresh, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
